<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="logo-icon mr-16" *fuseIfOnDom >apps</mat-icon>
        <span class="logo-text h1" *fuseIfOnDom >{{'main.learning_paths' | translate}}</span>
      </div>

      <div class="search-input-wrapper mx-12 m-md-0 width-5-10"
        fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">
        <label for="search" class="mr-8">
          <mat-icon class="secondary-text">search</mat-icon>
        </label>
        <mat-form-field floatLabel="never" fxFlex="1 0 auto" class="page-search">
          <mat-label>{{'main.search' | translate}}</mat-label>
          <input id="search" matInput #filter>
        </mat-form-field>
      </div>

      <button mat-raised-button
        [routerLink]="'/pages/learningPaths/detail'"
        class="add-product-button mat-white-bg my-12 mt-sm-0">
        <span>{{'learning_paths.add_new' | translate}}</span>
      </button>
      <button mat-button class="mat-icon-button sidenav-toggle ml-12"
        fuseMatSidenavToggler="sidenav"
        fxHide.gt-lg>
        <mat-icon>filter_list</mat-icon>
      </button>
    </div>
    <!-- / HEADER -->
    <mat-sidenav-container class="my-sidenav" [style.display]="sidenav.opened ? 'block' : 'none'">
      <mat-sidenav #sidenav class="sidenav mat-sidenav-opened" position="end" opened="true" mode="side"
        fuseMatSidenavHelper="sidenav" mat-is-locked-open="gt-sm" [ngClass]="{'hide-menu': !sidenav.opened}">
        <div class="sidenav-toggle-div">
          <button mat-button class="mat-icon-button sidenav-toggle ml-12"
            fuseMatSidenavToggler="sidenav"
            fxHide.gt-lg>
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <filter-menu [filters]="filterData" [page]="'learningPaths'"
        (chooseFilter)="chooseFilters($event)"></filter-menu>
      </mat-sidenav>
    </mat-sidenav-container>
    <!-- CONTENT CARD -->
    <div class="content-card mat-white-bg"
      [ngClass]="{'margin-big-screen': sidenav.opened}">
      <mat-table class="products-table"
        #table [dataSource]="learningPaths"
        [@animateStagger]="{value:'50'}"
        fusePerfectScrollbar
        id="learningPathsPage">

        <ng-container cdkColumnDef="title">
          <mat-header-cell [ngClass]="'customWidthClass'" *cdkHeaderCellDef>{{'learning_paths.title' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let lp" [ngClass]="'customWidthClass'">
            <p class="text-truncate">{{lp.title}}</p>
          </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="visibility">
          <mat-header-cell [ngClass]="'customWidthClass'" *cdkHeaderCellDef>{{'learning_paths.visibility' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let lp" [ngClass]="'customWidthClass'">
            <p class="text-truncate">{{lp.visibility}}</p>
          </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="participants">
          <mat-header-cell [ngClass]="'customWidthClass'" *cdkHeaderCellDef>{{'learning_paths.participants' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let lp" [ngClass]="'customWidthClass'">
            <p class="text-truncate">{{lp.participants}}</p>
          </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="startDate">
          <mat-header-cell [ngClass]="'customWidthClass'" *cdkHeaderCellDef >{{'learning_paths.startDate' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let lp" [ngClass]="'customWidthClass'" class="status">
            <p class="text-truncate">{{lp.startDate}}</p>
          </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="finishDate">
          <mat-header-cell [ngClass]="'customWidthClass'" *cdkHeaderCellDef >{{'learning_paths.finishDate' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let lp" [ngClass]="'customWidthClass'" class="status">
            <p class="text-truncate">{{lp.finishDate}}</p>
          </mat-cell>
        </ng-container>

        <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>


        <mat-row *cdkRowDef="let event; columns: displayedColumns;"
          class="product"
          matRipple
          [ngStyle]="{'background-color' : event.dayColor}"
          [routerLink]="'/pages/learningPaths/detail'" [queryParams]="{id: event.id}">
        </mat-row>

      </mat-table>
      @if (learningPaths.length === 0) {
        <div class="no-data-msg">
          <span class="mat-headline-6">{{'main.noData' | translate}}</span>
        </div>
      }
      <mat-paginator #paginator
        [length]="_total"
        [pageIndex]="_pageIndex"
        [pageSize]="_perPage"
        [pageSizeOptions]="[25, 50, 100]"
        (page)="changePageEmitter($event)">
      </mat-paginator>
    </div>
    <!-- / CONTENT CARD -->
  </div>
  <!-- / CENTER -->
</div>
